import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/skillDetail';

/**
 * スキル詳細情報のState型
 */
export interface ISkillDetailState {
	readonly skillInfo: Actions.ISkillDetail;
}

/**
 * スキル詳細情報画面のState初期値
 */
const initState: ISkillDetailState = {
	skillInfo: {
		applicationFlg: '', // 申込方法
		comment: '', // 備考
		compulsoryID: '', // 区分
		credit: undefined, // 単位
		inquiry: '', // 問い合わせ先
		managementCode: '', // 管理番号
		materialFileList: [], // スキル関連資料リスト
		necessaryCareerList: [], // スキル認定必要な研修一覧リスト
		outline: '', // 概要
		periodInfoList: [], // 実施期間情報一覧リスト
		purpose: '', // 目的
		ranksFlag: '', // ランク利用区分
		reference: '', // 申込み先
		referenceURL: '', // 申込み先URL
		scoreItemsRegisterFlag: '', // 得点内訳登録利用区分
		scoreRegisterFlag: '', // 得点登録利用区分
		skillId: '', // スキルID
		skillManager: '', // スキル管理者
		skillName: '', // スキル名
		subType: '', // サブ種別
		target: '', // 対象者
		type: '', // 種別
		vendor: '', // ベンダ名
		vendorURL: '', // ベンダURL
	},
};

const skillDetail = (state: ISkillDetailState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initState;
		state = initializeState(state);
	}

	// スキル詳細情報設定
	if (isType(action, Actions.setSkillDetail)) {
		let newState: ISkillDetailState = {
			...state,
			...action.payload,
			skillInfo: {
				...state.skillInfo,
				...action.payload.skillInfo,
			},
		};

		if (action.payload.skillInfo.materialFileList) {
			newState = {
				...newState,
				skillInfo: {
					...newState.skillInfo,
					materialFileList: action.payload.skillInfo.materialFileList.slice(),
				},
			};
		}

		if (action.payload.skillInfo.necessaryCareerList) {
			newState = {
				...newState,
				skillInfo: {
					...newState.skillInfo,
					necessaryCareerList: action.payload.skillInfo.necessaryCareerList.slice(),
				},
			};
		}

		if (action.payload.skillInfo.periodInfoList) {
			newState = {
				...newState,
				skillInfo: {
					...newState.skillInfo,
					periodInfoList: action.payload.skillInfo.periodInfoList.slice(),
				},
			};
		}

		return newState;
	}
	return state;
};

export default skillDetail;



// WEBPACK FOOTER //
// ./src/reducers/skillDetail.ts